module.exports = "/_next/static/images/Data-32f2437e3dd3b79b5ea08a3971e415ea.png";